export enum ParticipantStatus {
  READY = 'ready',
  STARTED = 'started',
  PAUSED = 'paused',
  TIME_UP = 'time_up',
  HELP_REQUESTED = 'help_requested',
  WAITING = 'waiting',
  COMPLETED = 'completed',
  ASSESSMENT_COMPLETE = 'assessment_complete',
}
